import { CityEscapeReviewsQuestionIds } from "../consts";
import { Match } from "../directus/collections";

export function asLandbotMatch(data: Match[]): Match[];
export function asLandbotMatch(data: Match): Match;
export function asLandbotMatch(data: Match | Match[]): Match | Match[];
export function asLandbotMatch(data: Match | Match[]) {
  return setOrigin(data, "landbot");
}

export function asDirectusMatch(data: Match[]): Match[];
export function asDirectusMatch(data: Match): Match;
export function asDirectusMatch(data: Match | Match[]): Match | Match[];
export function asDirectusMatch(data: Match | Match[]) {
  return setOrigin(data, "directus");
}

export function setOrigin(
  data: Match[],
  origin: "landbot" | "directus"
): Match[];
export function setOrigin(data: Match, origin: "landbot" | "directus"): Match;
export function setOrigin(
  data: Match | Match[],
  origin: "landbot" | "directus"
): Match | Match[];
export function setOrigin(
  data: Match | Match[],
  origin: "landbot" | "directus"
) {
  if (Array.isArray(data)) {
    return data.map(
      (m) =>
        ({
          ...m,
          origin,
        } as Match)
    );
  }

  return {
    ...data,
    origin,
  } as Match;
}

export function getOverallExperienceRating(match: Match): number | null {
  const fromRatings = Number(
    match.ratings?.find((r) =>
      CityEscapeReviewsQuestionIds.OVERALL_EXPERIENCE_RATING.includes(
        r.question
      )
    )?.value
  );
  const fromSurvey = Number(match.survey?.rating);

  if (!isNaN(fromRatings)) {
    return fromRatings || null;
  } else if (!isNaN(fromSurvey)) {
    return fromSurvey || null;
  } else {
    return null;
  }
}

export function getTextReview(match: Match): string | null {
  return (
    match.ratings?.find((r) =>
      CityEscapeReviewsQuestionIds.TEXT_REVIEW.includes(r.question)
    )?.text_value ?? null
  );
}

export function getPlayersCount(match: Match): number {
  return match.players?.length || match.survey?.team_members || 1;
}
